import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'notifications',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./noti/notifications.module').then((m) => m.NotificationModule),
  },
  {
    path: 'oport',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./oport/oport.module').then((m) => m.OportModule),
  },
  {
    path: 'challenges',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./challenge-module/challenge-module.module').then(
        (m) => m.ChallengeModule,
      ),
  },
  {
    path: 'free-companies',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./free-companies/free-companies.module').then(
        (m) => m.FreeCompaniesModule,
      ),
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'logs',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
  },

  {
    path: 'premium',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./premium/premium.module').then((m) => m.PremiumModule),
  },
  {
    path: 'standard',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./standard/standard.module').then((m) => m.StandardModule),
  },

  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
